<template>

  <b-col>
    <h1>Проекты <b-button v-if="false" variant="primary" :to="{name: 'project-add'}"><fa-icon icon="plus"/></b-button></h1>
    <b-row>
      <b-col md="3" v-for="project in appState.projects" :key="project.id">
        <b-card
          class="mb-3"
          :header="project.name"
        >
          <b-card-text>
            Домены: <span v-for="domain in project.domains" :key="domain">{{ domain }}</span>
          </b-card-text>
          <b-link :to="{name: 'project-edit', params: {projectId: project.id}}" class="btn btn-secondary">
            Редактировать
          </b-link>
        </b-card>
      </b-col>
    </b-row>
  </b-col>

</template>

<script>
import { store } from "@/store";

export default {
    name: 'ProjectList',
    data () {
        return {
            appState: store.state
        };
    }
};

</script>
